import serviceHandler from "@/helpers/handlers/service";
import facilitiesService from "@/services/facilities";
import facilitiesGroupsService from "@/services/facilitiesGroups";
import { FacilityModel } from "@/utils/google/facilities/facility-model";

const createFacilityModel = (facility, itemIndex) => {
  const model = new FacilityModel();
  model.makeFacilityModel({ facility, itemIndex });
  return model.returnFacilityModel();
};

export default {
  resetStore({ commit }) {
    commit("RESET_STORE");
  },

  setSelectedGroup({ commit }, group) {
    commit("SET_SELECTED_GROUP", group);
  },

  setSelectedGroupsIds({ commit }, groupsIds) {
    commit("SET_SELECTED_GROUPS_IDS", groupsIds);
  },

  async fetchFacilitiesGroups(
    { commit, state, dispatch },
    { page, perPage, query, fetchAllFacilitiesGroupsIds = false, groups = [] }
  ) {
    const facilitiesGroupsData = await serviceHandler(
      facilitiesGroupsService.getFacilitiesGroups({
        page,
        perPage,
        query,
        groups
      })
    );

    commit("SET_CURRENT_PAGE_FACILITIES_GROUPS", facilitiesGroupsData.results);
    commit("SET_GROUPS_TOTAL_COUNT", facilitiesGroupsData.count);

    if (fetchAllFacilitiesGroupsIds) {
      dispatch("fetchFacilitiesGroupsIds", {
        name: query,
        groups
      });
    }
  },

  async fetchFacilitiesGroupsIds({ commit }, data) {
    const facilitiesGroupsIds = await serviceHandler(
      facilitiesGroupsService.getFacilitiesGroupsIds(data)
    );
    commit(
      "SET_ALL_GROUPS_IDS",
      facilitiesGroupsIds.map(({ id }) => id)
    );
  },

  async fetchGroupFacilities(
    { commit, state },
    {
      page,
      perPage,
      query = null,
      cities = [],
      isOwner = true,
      facilitiesIds = [],
      groups = []
    }
  ) {
    const facilities = await serviceHandler(
      facilitiesService.getFacilitiesData({
        page,
        perPage,
        query,
        cities: cities,
        is_owner: isOwner,
        facilities_ids: facilitiesIds,
        groups: groups
      })
    );

    const data = facilities.results.map((facility, index) =>
      createFacilityModel(facility, index + 1 + (page - 1) * perPage)
    );
    commit("SET_CURRENT_PAGE_SELECTED_GROUP_FACILITIES", data);
    commit("SET_SELECTED_GROUP_FACILITIES_TOTAL_COUNT", facilities.count);
  },

  async fetchAllSelectedGroupFacilitiesIds({ commit }, groups) {
    const ids = await serviceHandler(
      facilitiesGroupsService.getFacilitiesIds(groups)
    );
    commit("SET_ALL_SELECTED_GROUP_FACILITIES_IDS", ids);
  },

  setSelectedGroupSelectedFacilities({ commit }, selectedFacilities) {
    commit("SET_SELECTED_GROUP_SELECTED_FACILITIES", selectedFacilities);
  },

  toggleFacilitiesGroup({ commit, state }, facilitiesGroupId) {
    const selectedIds = state.selectedGroupsIds;

    const foundIndex = selectedIds.findIndex(id => {
      return id === facilitiesGroupId;
    });

    if (foundIndex !== -1) {
      selectedIds.splice(foundIndex, 1);
    } else {
      selectedIds.push(facilitiesGroupId);
    }
    commit("SET_SELECTED_GROUPS_IDS", selectedIds);
  },

  toggleAllCurrentPageFacilitiesGroups({ commit, state, getters }) {
    const selectedIds = state.selectedGroupsIds;

    if (!getters.isAllCurrentPageFacilitiesGroupsSelected) {
      state.currentPageFacilitiesGroups.forEach(group => {
        if (selectedIds.findIndex(id => id === group.id) === -1) {
          selectedIds.push(group.id);
        }
      });
    } else {
      state.currentPageFacilitiesGroups.forEach(group => {
        const selectedIndex = selectedIds.findIndex(id => id === group.id);

        if (selectedIndex > -1) {
          selectedIds.splice(selectedIndex, 1);
        }
      });
    }

    commit("SET_SELECTED_GROUPS_IDS", selectedIds);
  },

  selectFacilitiesByFacilitiesIds({ state, dispatch }, facilitiesIds) {
    const selected = state.allGroupsIds.filter(id =>
      facilitiesIds.includes(id)
    );
    dispatch("setSelectedGroupsIds", selected);
  },

  toggleAllFacilitiesGroups({ commit, state, getters }) {
    if (!getters.isAllFacilitiesGroupsSelected) {
      commit("SET_SELECTED_GROUPS_IDS", [...state.allGroupsIds]);
    } else {
      commit("SET_SELECTED_GROUPS_IDS", []);
    }
  },

  toggleFacility({ commit, state, getters }, facility) {
    if (getters.isLabelGroupSelected) return;

    const selectedIds = state.selectedGroupSelectedFacilities;

    const foundIndex = selectedIds.findIndex(({ id }) => {
      return id === facility.id;
    });

    if (foundIndex !== -1) {
      selectedIds.splice(foundIndex, 1);
    } else {
      selectedIds.push(facility);
    }

    commit("SET_SELECTED_GROUP_SELECTED_FACILITIES", selectedIds);
  },

  toggleAllSelectedGroupFacilities({ commit, state, getters }) {
    if (!getters.isAllSelectedGroupFacilitiesSelected) {
      commit("SET_SELECTED_GROUP_SELECTED_FACILITIES", [
        ...state.allSelectedGroupFacilitiesIds
      ]);
    } else {
      commit("SET_SELECTED_GROUP_SELECTED_FACILITIES", []);
    }
  },

  toggleAllCurrentPageSelectedGroupFacilities({ commit, state, getters }) {
    const selected = state.selectedGroupSelectedFacilities;
    const currentPageFacilitesIds = state.currentPageSelectedGroupFacilities.map(
      ({ id }) => id
    );

    const currentPage = state.allSelectedGroupFacilitiesIds.filter(({ id }) =>
      currentPageFacilitesIds.includes(id)
    );

    if (!getters.isAllCurrentPageSelectedGroupFacilitiesSelected) {
      currentPage.forEach(currentItem => {
        if (selected.findIndex(({ id }) => id === currentItem.id) === -1) {
          selected.push(currentItem);
        }
      });
    } else {
      currentPage.forEach(currentItem => {
        const selectedIndex = selected.findIndex(
          ({ id }) => id === currentItem.id
        );

        if (selectedIndex > -1) {
          selected.splice(selectedIndex, 1);
        }
      });
    }

    commit("SET_SELECTED_GROUP_SELECTED_FACILITIES", selected);
  }
};
